import React, { useEffect, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import { Title } from "../../atoms";
import { ActionButton } from "../../atoms";
import { TextField } from "../../atoms";
import { NumberField } from "../../molecules";

const getVariantTitle = (variant) => {
  const { option1, option2 } = variant;
  if (option2) {
    return `${option1}, ${option2}`;
  }
  return `${option1}`;
};

const VariantEdit = ({
  isBat,
  onCancelClick,
  variant,
  onSave,
  productWeights,
  weightTitle,
  isService
}) => {
  const {
    formState: {
      errors: { variants },
    },
    getValues,
    control,
    setValue,
  } = useFormContext();

  const onSubmit = () => {
    onSave();
  };
  const [price, setPrice] = useState(variant.price);
  const [quantity, setQuantity] = useState(variant.inventoryQuantity);
  const [weight, setWeight] = useState(variant.weight);
  
  useEffect(() => {
    setPrice(variant.price);
    setQuantity(variant.inventoryQuantity);

    setValue(`variants[${variant.index}].price`, variant.price);
    setValue(`variants[${variant.index}].inventoryQuantity`, variant.inventoryQuantity);
    setValue(`variants[${variant.index}].weight`, variant.weight);
  }, [variant, setValue]);
 
  const variantTitle = getVariantTitle(variant);
  return (
    <div className="w-100 pt-2 px-4">
      <form onSubmit={onSubmit}>
        <div className="formLayer0">
          <Title text={variantTitle} className="addItemCls" />
          <ActionButton
            text="CANCEL"
            onClick={onCancelClick}
            className="productCancelCls"
            style={{ display: "block" }}
          />
        </div>
        <div>
          <div className="formLayer3">
            <Title text={"Price (£)"} className="formLabelCls" />
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Controller
                name={`variants[${variant.index}].price`}
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => (
                  <TextField
                   step={"0.01"}
                    type="number"
                    className="productField1"
                    {...field}
                    isError={price < 1}
                    errorText={<span style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                    price can't be less than £1
                  </span>}
                    placeholder={price}
                    onChange={(e) => {
                      setPrice(e.target.value);
                      field.onChange(e);
                    }}
                  />
                )}
              />
            </div>
          </div>
          {!isService && <div className="formLayer3">
            <Title text={"Quantity"} className="formLabelCls" />
            <Controller
              name={`variants[${variant.index}].inventoryQuantity`}
              rules={{
                required: true,
              }}
              control={control}
              render={({ field }) => (
                <TextField
                  type="number"
                  min="0"
                  className="productField1"
                  {...field}
                  isError={!!variants?.[variant.index]?.inventoryQuantity}
                  errorText={""}
                  placeholder={quantity}
                    onChange={(e) => {
                      setQuantity(e.target.value);
                      field.onChange(e);
                    }}
                />
              )}
            />
          </div>}
          
          {/* <div className="formLayer3">
            <Title text={"Weight"} className="formLabelCls" />
            <Controller
              name={`variants[${variant.index}].weight`}
              control={control}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="number"
                  className="productField1"
                  isError={!!variants?.[variant.index]?.weight}
                  errorText={""}
                />
              )}
            />
          </div> */}
          {!isBat && !isService ? (
            <div className="formLayer3">
              <Title text={weightTitle} className="formLabelCls" />
            
                  <Controller
                    name={`variants[${variant.index}].weight`}
                    control={control}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => {
                      const list = productWeights.map((m) => ({
                        value: m.weight,
                        label: m.weight,
                      }));

                      return (
                        <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: 150, height: 45 }}>
                          <CreatableSelect
                            isClearable={true}
                            placeholder={weight ?? "Please select"}
                            
                            onChange={(val) => {
                            
                              if(val === null || val === undefined) {
                                
                                setWeight("");
                                  field.onChange("")
                                  setValue(`variants[${variant.index}].weight`, "");
                              }
                              else if(val.value){

                                if(isNaN(val.value)) return;
                                
                                  setWeight(val.value);
                                  field.onChange(val.value)
                                  setValue(`variants[${variant.index}].weight`, val.value);
                                }
                              }}
                            options={list}
                            value={{ value: weight, label: weight }}
                            isSearchable={true}
                            onInputChange={(inputValue) => {
                              if(isNaN(inputValue)) return;

                              if(inputValue === "" && weight === "") {
                               
                                setWeight("");
                                  field.onChange("")
                                  setValue(`variants[${variant.index}].weight`, "");
                              }else if(inputValue != ""){
                              const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
                                  setWeight(sanitizedValue);
                                  
                                  setValue(`variants[${variant.index}].weight`, sanitizedValue);
                                  //field.onChange(sanitizedValue)
                              }
                            }}
                            //inputValue={weight}
                            //formatCreateLabel={(weight) => `Add "${weight}"`}
                          />
                        </div>
                        </>
                      );
                    }}
                  />
               
            </div>
          ) : null}
          {price >= 1 && (
            <div className="d-flex flex-column align-items-center mt-5 mb-5">
              <ActionButton
                text="SAVE"
                type="submit"
                isLoading={false}
                marginTop={3}
                disabled={false}
              />
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default VariantEdit;
